import { Controller } from "@hotwired/stimulus"
import { Calendar } from 'fullcalendar';

// Connects to data-controller="visits-calendar"
export default class extends Controller {
    static targets = ["calendar"];
    static values = {
      events: Array
    }
  
  connect() {
    let calendarEl = this.calendarTarget;

    var calendar = new Calendar(calendarEl, {
      initialView: 'list',
      aspectRatio: 3.5,
      headerToolbar: false,
      visibleRange: {
        start: '1900-01-01',
        end: '3000-01-01'
      },
      events: this.eventsValue,
      displayEventTime: false,
      eventSourceSuccess: function () {
        setTimeout(() => {
          reverseListView();
        }, 100); // Delay to ensure DOM is rendered
      },
    });

    calendar.render();

    function reverseListView() {
      let container = document.querySelector('[role="list"]');
      let rows = Array.from(container.children);
      rows.reverse().forEach((row) => container.appendChild(row)); // Reorder rows in DOM
    }
  }
}
